import { ref, watch, computed } from '@vue/composition-api'
import store from '@/store'
import { title } from '@core/utils/filter'

// Notification
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default function usePharmaciensList() {
  // Use toast
  const toast = useToast()

  const refPharmacienListTable = ref(null)
  const searchQuery = ref('')
  
  // Table Handlers
  const tableColumns = [
    { key: 'fullName', label: 'Nom', sortable: true },
    { key: 'email', label: 'Email', sortable: true },
    { key: 'phone' , label: 'Téléphone', sortable: true },
    { key: 'status', label: 'Statut', sortable: true },
    { key: 'type_pharmacien', label: 'Type pharmacien', sortable: true },
    { key: 'actions', label: 'Actions'  },
  ]
  const perPage = ref(10)
  const totalUsers = ref(0)
  const currentPage = ref(1)
  const perPageOptions = [10, 25, 50, 100]
  const sortBy = ref('fullName')
  const isSortDirDesc = ref(false);

  const dataMeta = computed(() => {
    const localItemsCount = refPharmacienListTable.value ? refPharmacienListTable.value.localItems.length : 0
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalUsers.value,
    }
  })

  const refetchData = () => {
    refPharmacienListTable.value.refresh()
  }

  watch([currentPage, perPage, searchQuery], () => {
    refetchData()
  })

  const fetchListPharmacien = (ctx, callback) => {
    store
      .dispatch('app-pharmacien/getListPharmacien', {
        q: searchQuery.value,
        perPage: perPage.value,
        page: currentPage.value,
        sortBy: sortBy.value,
        sortDesc: isSortDirDesc.value
      })
      .then(response => {
        const data = response.data.data.data;
        // const pharmaciens = data.map(x => {
        //   return {
        //     id: x?.idNormal,
        //     fullName: (x?.first_name ? x?.first_name : 'Non') + " " + (x?.last_name ? x?.last_name : 'Défini'),
        //     nom:  x.last_name != null ? x.last_name.toUpperCase() : x.last_name,
        //     prenom: x.first_name != null ? x.first_name.toUpperCase() : x.first_name,
        //     email: x.email, 
        //     phone: x.phone,
        //     status: x.isBlock,
        //     type_pharmacien: x.typeAuth,
        //     isBlockBtn: x.isBlockBtn
        //   }
        // });
        callback(data)
        totalUsers.value = response.data.data.total;
      })
      .catch(() => {
        toast({
          component: ToastificationContent,
          props: {
            title: 'Error fetching users list',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      }) 
  }

  // *===============================================---*
  // *--------- UI ---------------------------------------*
  // *===============================================---*

  const resolvePharmacienStatusVariant = status => {
    if (status === 'bloquer') return 'danger'
    if (status === 'actif') return 'success'
    if (status === 'inactif') return 'warning'
    return 'primary'
  }

  return {
    fetchListPharmacien,
    tableColumns,
    perPage,
    currentPage,
    totalUsers,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refPharmacienListTable,

    // resolveUserRoleVariant,
    // resolveUserRoleIcon,
    resolvePharmacienStatusVariant,
    refetchData,

  }
}
